module.exports = __webpack_public_path__ + "img/1-about.8c4764d4.jpg";